import { DocumentTemplate } from "./document-template";
import { TaskType } from "./task-type.enum";
import { TaskExecutionType } from "./task-execution-type.enum";
import { DictionaryEntry } from "@sdbn/common";

export class TaskDetails {
  id: number;
  name: DictionaryEntry;
  type: TaskType;
  message: DictionaryEntry;
  executionType: TaskExecutionType;
  sortOrder: string;
  documentTemplate: DocumentTemplate;
  processingHint: string;
  orderReferenceOld: string;
  orderReferenceNew: string;

  constructor(details?: Partial<TaskDetails>) {
    this.id = details?.id;
    this.name = new DictionaryEntry(details?.name);
    this.type = details?.type;
    this.message = new DictionaryEntry(details?.message);
    this.executionType = details?.executionType;
    this.sortOrder = details?.sortOrder;
    this.documentTemplate = details?.documentTemplate;
    this.processingHint = details?.processingHint;
    this.orderReferenceOld = details?.orderReferenceOld;
    this.orderReferenceNew = details?.orderReferenceNew;
  }
}
